<template>
  <div id="home">

    <br />
    <br />
    <br />

    <img alt="logo" src="../assets/logo.png" /><br />
    <br />
    <br />
    <br />
    <router-link tag="Button" class="loginbutton" to="/login"
      >Log in <i class="pi pi-sign-in p-m-1"></i
    ></router-link>
    <router-link tag="Button" class="p-ml-3 registerbutton" to="/signup"
      >Sign up <i class="pi pi-user-plus p-m-1"></i
    ></router-link>
    <p>
      Welcome to PMCSx! <br />
      <b>The digital</b> e<b>X</b>tension of <b>Army Maintenance</b>
    </p>
    <br/>

    <router-link to="/forgotpassword"
      ><small>Forgot Password?</small></router-link
    >
            <h6 class="details">
      <small class="level-item" style="color: var(--textLight)">
        Developed by 4-25th IBCT (ABN) Soldier Coders
      </small>
    </h6>
    <p class="details">
      <small class="level-item" style="color: var(--textLight)">
        &copy; SPARwerx. All Rights Reserved.
      </small>
    </p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
body,
html,
#app {
  background-color: #BB4a4a;
}

#home {
  font-size: 20px;
}

img {
  width: 200px;
}

.registerbutton {
  background-color: white;
  border-color: white;
}

.registerbutton:enabled:hover,
.registerbutton:enabled:active {
  color: white;
  border-color: #FFCC5C;
}

.registerbutton:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem white;
}

.loginbutton {
  background-color: #FFCC5C;
  border-color: #FFCC5C;
}

.loginbutton:enabled:hover,
.loginbutton:enabled:active {
  color: white;
  border-color: #FFCC5C;
}

.loginbutton:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem white;
}

h1 {
  text-shadow: 4px 4px 6px #999999;
}

p {
  text-shadow: 2px 2px 4px #999999;
}
</style>